import { styles } from "./styles";
import { CardTagProps } from "./types";
import { Stack } from "@mui/material";

export const CardTag = ({ title, description }: CardTagProps) => {
  return (
    <Stack css={styles.cardtag}>
      <Stack css={styles.cardtag_blue}>{title}</Stack>
      <Stack css={styles.cardtag_icon}>=</Stack>
      <Stack css={styles.cardtag_orange}>{description}</Stack>
    </Stack>
  );
};
